<template>
    <div>
        <div>
            <span :class="getClass()">{{statusText}}</span>
        </div>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import {getWorkflowStatusClass} from "@/config/mUtils"
export default {
    props: {
        data: {},
    },
    data() {
        return {
            status: 0,
            statusText: ''
        };
    },
    components: {},
    created() {
        this.init();
    },
    methods: {
        init() {
            if (!!this.data) {
                this.status = this.data.Status;
                this.statusText = this.data.StatusText;
            }
        },
        getClass(){
            return getWorkflowStatusClass(this.status);
        }
    },
    watch: {
        data: function() {
            this.init();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/autoWorkflowStatusCell.vue